import { AutoMap } from "@automapper/classes";
import { ETypePrelevementAir } from "./enum/type-prelevement-air";

export class PrelevementAir {
    @AutoMap()
    Type!: ETypePrelevementAir;
    @AutoMap()
    ReferenceTube!: string;
    @AutoMap()
    Duree!: number;
    @AutoMap()
    Resultat!: string;
    @AutoMap()
    Conformite!: boolean;
}